import React from 'react';
import { number, oneOf, shape, string } from 'prop-types';
import cx from 'classnames';
import { round } from 'lodash';

import formatMinutesSeconds from 'helpers/formatMinutesSeconds';

import Tooltip from 'components/Map/MapComponents/Tooltip';
import TooltipItem from 'components/Map/MapComponents/TooltipItem';
import SpeedTrendIcon from 'components/SpeedTrendIcon';

import RouteIcon from 'icons/panel-route.inline.svg';
import RouteBrokenIcon from 'icons/panel-route-broken.inline.svg';

import styles from './route-tooltip.scss';

// @TODO use new components: WithTrend, SpeedDisplay, TimeDisplay, SegmentNameDisplay
export default function RouteTooltip({ status, name, liveTravelTime, travelTimeTrend, distance }) {
  const isReporting = status !== 'disconnected';

  return (
    <Tooltip sticky offset={[5, -10]} className={cx(styles.main, styles[`status-${status}`])}>
      <TooltipItem label={isReporting ? 'travel time' : 'status'} status={status}>
        {isReporting
          ? <div className={styles.liveTravelTime}>
              {travelTimeTrend &&
                <SpeedTrendIcon trend={travelTimeTrend} className={styles.trendIcon} />}
              <span className={styles.speedNumber}>
                {formatMinutesSeconds(liveTravelTime, { useClockFormat: true })}
              </span>
            </div>
          : <div className={styles.statusText}>Disconnected</div>}
      </TooltipItem>
      <TooltipItem label="route">
        <div className={styles.route}>
          {isReporting
            ? <RouteIcon width={6} className={styles.routeIcon} />
            : <RouteBrokenIcon width={6} className={styles.routeIcon} />}
          <div className={styles.routeName}>
            <div>
              {name.from}
            </div>
            <div>
              {name.to}
            </div>
          </div>
        </div>
      </TooltipItem>
      <TooltipItem label="distance">
        <div className={styles.distance}>
          <span className={styles.distanceNumber}>
            {round(distance, 2)} <span className={styles.unit}>miles</span>
          </span>
        </div>
      </TooltipItem>
    </Tooltip>
  );
}

RouteTooltip.propTypes = {
  status: oneOf(['ok', 'warning', 'problem', 'disconnected']).isRequired,
  name: shape({ to: string.isRequired, from: string.isRequired }).isRequired,
  liveTravelTime: number.isRequired,
  travelTimeTrend: oneOf(['up', 'down']),
  distance: number.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/Map/MapComponents/RouteTooltip/index.js